import React from 'react';

const Icon: React.FC<{ type?: any; className?: any }> = (props) => {
  const { type, className } = props;
  return <>{React.createElement(type, { className })}</>;
};

export default React.memo(Icon);
